
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card } from "@mui/material";
import axios from "axios";
import Config from "../config";
import "../Final_Css/positiveflowbuttons.css";
import "./VivaInstructions.css";
import DeviceTestPopup from "./DeviceTestPopup";
import DeviceTestSuccessPopup from "./DeviceTestSuccessPopup";
import DeviceTestErrorPopup from "./DeviceTestErrorPopup";




const VivaInstructions = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [instructions, setInstructions] = useState([]);
  const [showDevicePopup, setShowDevicePopup] = useState(false);
  const [deviceTestPassed, setDeviceTestPassed] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [micActive, setMicActive] = useState(false);
  const [testingDevices, setTestingDevices] = useState(false);
  const [micLevel, setMicLevel] = useState(0);

  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [stoppingTest, setStoppingTest] = useState(false);

  const location = useLocation();

  const navigate = useNavigate();
  const { ee_id } = useParams();

  const videoRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const [deviceTestSuccess, setDeviceTestSuccess] = useState(false);
  const examStatus = location.state?.status || "Start";
  console.log(examStatus);



  const enterFullscreen = async () => {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      await elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  const showDeviceError = (message) => {
    stopDeviceTest();

    setShowDevicePopup(false);

    setShowSuccess(false);

    setDeviceTestPassed(false);

    setDeviceTestSuccess(false);

    setErrorMessage(message);

    setShowErrorPopup(true);
  };


  // Fetch instructions from backend
  useEffect(() => {
    if (!ee_id) return;

    const fetchInstructions = async () => {
      try {
        const res = await axios.get(
          `/employee/instructions/`,
          { withCredentials: true }
        );

        const raw = res.data.instructions?.[0]?.Instructions;
        if (!raw) return setInstructions([]);

        const parsed = JSON.parse(raw); // [{ heading, points: [...] }]
        setInstructions(parsed);
      } catch (err) {
        console.error("Error fetching Viva instructions:", err);
        setInstructions([]);
      }
    };

    fetchInstructions();
  }, [ee_id]);



  const handleDeviceTestClick = () => {
    setDeviceTestPassed(false);
    setDeviceTestSuccess(false);
    setShowDevicePopup(true);
    handleDeviceTest();
  };

  // Stop camera/mic and show success popup
  // const handleStopTest = () => {
  //   stopDeviceTest();

  //   setShowDevicePopup(false);
  //   setDeviceTestPassed(true);   // enable Start Exam
  //   setShowSuccess(true);        // show success popup
  // };

  const handleStopTest = async () => {

    if (stoppingTest) return;

    setStoppingTest(true);
    try {
      const canvas = document.createElement("canvas");

      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(videoRef.current, 0, 0);

      const frameBlob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/jpeg")
      );

      const recorder = new MediaRecorder(mediaStreamRef.current);

      let audioChunks = [];

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          audioChunks.push(e.data);
        }
      };

      recorder.start();

      await new Promise((r) => setTimeout(r, 2000));

      recorder.stop();

      const audioBlob = await new Promise((resolve) => {
        recorder.onstop = () =>
          resolve(new Blob(audioChunks, { type: "audio/webm" }));
      });

      const formData = new FormData();

      formData.append("frame", frameBlob, "frame.jpg");
      formData.append("audio", audioBlob, "audio.webm");

      const response = await axios.post("/viva/device-test/", formData);

      stopDeviceTest();

      setShowDevicePopup(false);

      if (response.data.status === "success") {
        setDeviceTestPassed(true);
        setShowSuccess(true);
      } else {
        showDeviceError(response.data.message);
      }
    } catch (err) {
      showDeviceError(
        err.response?.data?.message || "Device test failed."
      );
    } finally {
      setStoppingTest(false);
    }
  };


  // Device test logic
  const handleDeviceTest = async () => {
    try {
      setTestingDevices(true);
      setMicActive(false);

      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      mediaStreamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
      }

      const audioContext =
        new (window.AudioContext || window.webkitAudioContext)();

      const source =
        audioContext.createMediaStreamSource(stream);

      const analyser = audioContext.createAnalyser();

      source.connect(analyser);

      const dataArray = new Uint8Array(analyser.frequencyBinCount);

      const micInterval = setInterval(() => {
        analyser.getByteFrequencyData(dataArray);

        const volume =
          dataArray.reduce((sum, val) => sum + val, 0) /
          dataArray.length;

        setMicLevel(Math.min(100, volume * 2));

        if (volume > 5) {
          setMicActive(true);
        }
      }, 300);

    } catch (err) {
      showDeviceError(
        err.response?.data?.message ||
        "Camera or microphone access denied."
      );
    }
  };
  const stopDeviceTest = () => {
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((t) => t.stop());
      mediaStreamRef.current = null;
    }
  };


  const handleStartExam = async () => {
    try {
      setLoading(true);
      await enterFullscreen();

      const storedQuestionIds =
        JSON.parse(localStorage.getItem("vivaQIds")) || [];


      // const payload = {
      //   user_id: "1",
      //   user_name: "TestUser",
      //   plant_id: 101,
      //   ee_id,
      //   exam_title: "Viva Exam",
      //   questions: storedQuestionIds.map((item) => ({
      //     QuestionId: item.Id.toString(),
      //   })),
      // };
      if (examStatus.toLowerCase() === "start") {

        const response = await axios.post(
          `/viva/save_exam_details/`,
          // payload,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data.id) {
          // Save session id
          localStorage.setItem("vivaExamSessionId", response.data.id);

          // 🔹 Replace local question IDs with backend IDs
          if (response.data.question) {
            localStorage.setItem(
              "vivaQIds",
              JSON.stringify(response.data.question)
            );
          }

          console.log("Backend questions:", response.data.question);

          // optional duration
          if (response.data.duration) {
            localStorage.setItem("vivaExamDuration", response.data.duration);
          }

          navigate(`/vivaexam/${ee_id}`);
        }
      } else if (examStatus.toLowerCase() === "resume") {
        navigate(`/vivaexam/${ee_id}`);
      }
    } catch (err) {
      console.log(err);

      const errorMessage =
        err.response?.data?.details?.error ||   // nested API error
        err.response?.data?.error ||            // direct API error
        "Failed to start Viva exam. Please try again.";
      console.log(err.response)
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseInstructions = () => window.history.back();

  return (
    <>
      {/* --------------------- Instructions Popup --------------------- */}
      {!showDevicePopup && !showSuccess && (
        <div className="exam-popup-overlay">
          <Card className="exam-popup-container">
            <header className="exam-instructions-header">
              <h2>Viva Assessment Instructions</h2>
            </header>
            <main className="exam-instructions-body">
              {instructions.length > 0 ? (
                instructions.map((section, sIdx) => (
                  <div key={sIdx} className="instruction-section">
                    {section.heading && (
                      <h3 className="instruction-heading">{section.heading}</h3>
                    )}
                    <ol className="instruction-list">
                      {section.points?.map((point, pIdx) => (
                        <li key={pIdx} className="instruction-item">
                          {point}
                        </li>
                      ))}
                    </ol>
                  </div>
                ))
              ) : (
                <p>No instructions available</p>
              )}

              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="confirm-read"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                  style={{ accentColor: "var(--theme-accent)" }}
                />
                <label htmlFor="confirm-read">
                  I have read and understood the instructions
                </label>
              </div>

              <div className="buttons-container">
                <button
                  className="btn-negative"
                  onClick={handleCloseInstructions}
                  disabled={loading}
                >
                  Cancel
                </button>

                <button
                  className="btn-secondary"
                  onClick={handleDeviceTestClick}
                >
                  Test Camera & Mic
                </button>

                <button
                  className="btn"
                  disabled={!isChecked || !deviceTestPassed || loading}
                  onClick={handleStartExam}
                >
                  {/* {loading ? "Starting..." : "Start Assessment"} */}
                  {loading
                    ? (examStatus === "Resume" ? "Resuming..." : "Starting...")
                    : (examStatus === "Resume" ? "Resume Assessment" : "Start Assessment")
                  }
                </button>
              </div>
            </main>
          </Card>
        </div>
      )}

      {/* --------------------- Camera / Device Popup --------------------- */}
      {showDevicePopup && (
        <div className="exam-popup-overlay">
          <DeviceTestPopup
            videoRef={videoRef}
            micLevel={micLevel}
            micActive={micActive}
            onStopTest={handleStopTest}
            stoppingTest={stoppingTest}
          />
        </div>
      )}
      {/* --------------------- Success Popup --------------------- */}
      {showSuccess && (
        <div className="exam-popup-overlay">
          <DeviceTestSuccessPopup
            onClose={() => setShowSuccess(false)}
          />
        </div>
      )}

      {showErrorPopup && (
        <DeviceTestErrorPopup
          message={errorMessage}
          onClose={() => {
            setShowErrorPopup(false);
            setErrorMessage("");
          }}
        />
      )}
    </>
  );
};

export default VivaInstructions;
